import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

let cachedFlags = null;

export const useFeatureFlags = () => {
  const [flags, setFlags] = useState(cachedFlags || {});
  const [loading, setLoading] = useState(!cachedFlags);

  useEffect(() => {
    const fetchFlags = async () => {
      try {
        const response = await axios.get(`${API}/feature-flags`);
        const flagsData = response.data.flags;
        cachedFlags = flagsData;
        setFlags(flagsData);
      } catch (error) {
        console.error('Failed to fetch feature flags:', error);
      } finally {
        setLoading(false);
      }
    };

    if (!cachedFlags) {
      fetchFlags();
    }
  }, []);

  const isEnabled = (flagKey) => {
    return flags[flagKey] === true;
  };

  const refresh = async () => {
    const response = await axios.get(`${API}/feature-flags`);
    const flagsData = response.data.flags;
    cachedFlags = flagsData;
    setFlags(flagsData);
  };

  return { flags, loading, isEnabled, refresh };
};
